export default __webpack_public_path__ + "static/media/main-demo-card.ffa1af9a.png";